<button
	type="button"
	class="btn btn-sm d-inline-flex align-items-center justify-content-center gap-2 border bg-white text-nowrap"
	tooltipStyleClass="custom-tooltip"
	[tooltipPosition]="'top'"
	[pTooltip]="'Set order status to not reviewed'"
	(click)="loadConfirm()"
	[disabled]="disableButton"
>
	Not Reviewed
</button>
